import { SelectedCard, Card } from '../card.model';

export interface State {
  selectedCard: SelectedCard;
  cardSearchOption: string;
  binFound: boolean;
  binNumber: string;
  cards: Card[];
  alternativeBin: boolean;
}

export const emptyState: State = {
  selectedCard: null,
  cardSearchOption: 'Bin',
  binFound: null,
  binNumber: null,
  cards: null,
  alternativeBin: null
}

export const initialState = emptyState;
